import axios from '@dap/shared-utils/http.js';

export default {
    getListData (params = {}, type = 'facebook') {
        if (type === 'gdt') {
            return axios.get('/dapper/api/aud/audiences', { params });
        }
        const typeMap = new Map();
        typeMap.set('facebook', 'fb_audiences');
        typeMap.set('kuaishou', 'ks_audiences');
        return axios.get(`/dapper/api/aud/${typeMap.get(type)}/list`, {
            params,
        });
    },

    getRelationLog (params = {}, type = 'relation', platform = 'facebook') {
        const typeMap = new Map();
        typeMap.set('facebook', 'fb_audiences');
        typeMap.set('kuaishou', 'ks_audiences');
        return axios.get(`/dapper/api/aud/${typeMap.get(platform)}/${type}`, {
            params,
        });
    },

    getListDetailData (params = {}) {
        return axios.get('/dapper/api/aud/fb/audience_detail', { params });
    },

    changeStatus (params = {}) {
        return axios.get('/dapper/api/aud/fb/switch_status', { params });
    },

    deleteData (params = {}) {
        return axios.delete('/dapper/api/aud/fb_audiences', { params });
    },

    kuaishouDeleteData (params = {}) {
        return axios.delete('/dapper/api/aud/ks_audiences', { params });
    },

    getKuaishouDict (params = {}) {
        return axios.get('/dapper/api/aud/ks_dict', { params });
    },

    getKuaishouDetailData (params = {}) {
        return axios.get('/dapper/api/aud/ks_audiences/detail', { params });
    },

    changeKuaishouStatus (params = {}) {
        return axios.put('/dapper/api/aud/ks_audiences/switch_status', params);
    },
};
